import projection from '../generated/pwc514f1.json';
import { AcceptanceManifest } from '../types';
export const pwc514f1AcceptanceManifest = projection as AcceptanceManifest;
